import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@systemeio/ui';
import { ContactTagInterface } from 'modules/contacts/types/contact-interface';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ContactTagBubbleProps {
  tags: ContactTagInterface[];
}
const ContactTagBubbles = t0 => {
  const $ = _c(8);
  const {
    tags
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== tags) {
    t1 = tags.slice(0, 2).map(_temp);
    $[0] = tags;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t || $[3] !== tags) {
    t2 = tags.length > 2 && <Tooltip stayOnHover={true} popoverClassName="p-0" anchor={{
      to: "top"
    }} label={<div className="bg-background-secondary shadow-3xl z-50 rounded-lg"><div className=" bg-background-secondary relative w-fit max-w-[400px] whitespace-normal rounded-lg px-5 py-3"><div className="text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium"><ul className="flex w-full flex-wrap gap-3">{tags.slice(2).map(_temp2)}</ul></div></div></div>}>{show => <button type="button" className={`main-transition-colors bg-background-primary text-text-primary hover:bg-brand-primary hover:text-background-secondary focus-visible:bg-brand-primary focus-visible:text-background-secondary rounded-full px-3 py-1.5 outline-hidden ${show && "bg-brand-primary text-background-secondary"}`}>{t("dashboard.contacts.plus_more_tags", {
          count: tags.length - 2
        })}</button>}</Tooltip>;
    $[2] = t;
    $[3] = tags;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <ul className="flex flex-wrap gap-3">{t1}{t2}</ul>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default ContactTagBubbles;
function _temp(el) {
  return <li key={el.id} className="bg-background-primary text-text-primary h-fit rounded-full px-3 py-1.5">{el.name}</li>;
}
function _temp2(el_0) {
  return <li key={el_0.id} className="bg-background-primary text-text-primary h-fit rounded-full px-3 py-1.5">{el_0.name}</li>;
}